import React, { useEffect, useState } from 'react';
import styles from './VoucherModal.module.scss';
import Modal from '../Modal/Modal';
import { TelegramSticker } from '@/components/TelegramSticker';
import WebApp from '@twa-dev/sdk';

interface VoucherModalProps {
  open: boolean;
  onClose: () => void;
}

const VoucherModal: React.FC<VoucherModalProps> = ({ open, onClose }) => {
  if (!open) return null;

  const handleParticipate = async () => {
    // Добавляем вибрацию при нажатии на кнопку
    if (WebApp && WebApp.HapticFeedback) {
      WebApp.HapticFeedback.notificationOccurred('success');
    } else {
      console.warn('Telegram WebApp or HapticFeedback is not available');
    }
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose}>
      <div>
        <h2 className={styles.title}>
          Раздел с промокодами
          <br /> вскоре станет доступен!
        </h2>
        <div className={styles.stickerWrapper}>
          <TelegramSticker
            tgsUrl="./vouchermodal.tgs"
            style={{ width: 110, height: 110 }}
            loop={false}
            autoplay={true}
          />
        </div>

        <button className={styles.withdrawButton} onClick={handleParticipate}>
          Окей, жду!
        </button>
      </div>
    </Modal>
  );
};

export default VoucherModal;
